import { render, staticRenderFns } from "./NotificationDropDown.vue?vue&type=template&id=72b90bf1&"
import script from "./NotificationDropDown.vue?vue&type=script&lang=js&"
export * from "./NotificationDropDown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDropDown.vue?vue&type=style&index=0&id=72b90bf1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports